import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import SellerInventoryBatchPhotoEditStatusBadge from 'domains/seller-inventory-batch/atoms/photo-edit-status-badge'
import SellerInventoryBatchPhotoReceivedStatusBadge from 'domains/seller-inventory-batch/atoms/photo-received-status-badge'
import SellerInventoryBatchPhotoUploadStatusBadge from 'domains/seller-inventory-batch/atoms/photo-upload-status-badge'
import SellerInventoryBatchPhotographyStatusBadge from 'domains/seller-inventory-batch/atoms/photography-status-badge'
import SellerInventoryBatchPutAwayStatusBadge from 'domains/seller-inventory-batch/atoms/put-away-status-badge'
import {
  PHOTOGRAPHY_STATUSES,
  PHOTO_EDIT_STATUSES, PHOTO_RECEIVED_STATUSES,
  PHOTO_UPLOAD_STATUSES, PUT_AWAY_STATUSES
} from 'domains/seller-inventory-batch/constants'
import PriceConfirmationStatusBadge from 'domains/seller-product-price-confirmation/atoms/status-badge'
import { STATUS } from 'domains/seller-product-price-confirmation/constants'
import SellerProductConfrimPriceStatusBadge from 'domains/seller-product/atoms/confirm-price-status-badge'
import SellerProductCurationStatusBadge from 'domains/seller-product/atoms/curation-status-badge'
import SellerProductLiveProcessStatusBadge from 'domains/seller-product/atoms/live-process-status'
import SellerInboundCurationStatusBadge from 'domains/seller-inbound/atoms/curation-status-badge'
import {
  CONFIRM_PRICE_STATUS,
  CURATION_STATUS,
  LIVE_PROCESS_STATUS
} from 'domains/seller-product/constants'
import TlRejectReasonBadge from 'domains/seller-rejected-product/atoms/reject-reason-badge'
import { REJECT_REASON } from 'domains/seller-rejected-product/constants'
import SellerBadge from 'domains/seller/atoms/seller-badge'
import { SELLER_TYPE } from 'domains/seller/constants/seller-constants'
import PropTypes from 'prop-types'
import React from 'react'
import StringUtils from 'utils/string-util'
import TimeUtil from 'utils/time-util'


const propTypes = {
  rowButtonProps: PropTypes.arrayOf(
    PropTypes.shape({
      isDisabled : PropTypes.func,
      colour     : PropTypes.string,
      onClick    : PropTypes.func,
      text       : PropTypes.string
    })
  )
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}

/**
 * Columns definition for Seller Product Table
 * @param {array} rowButtonProps - Array props for row button
 */
const sellerProductTableColumns = ({
  rowButtonProps
}) => {
  // Custom filter
  // ** SELLER **
  const SellerTypeFilter = ({ column }) => {
    const options = Object.keys(SELLER_TYPE).map((key) => (
      {
        label : SELLER_TYPE[key],
        value : SELLER_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  SellerTypeFilter.propTypes = filterPropTypes

  // ** SELLER PRODUCT **
  const CurationStatusFilter = ({ column }) => {
    const options = Object.keys(CURATION_STATUS).map((key) => (
      {
        label : CURATION_STATUS[key],
        value : CURATION_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  CurationStatusFilter.propTypes = filterPropTypes

  const PriceConfirmStatusFilter = ({ column }) => {
    const options = Object.keys(CONFIRM_PRICE_STATUS).map((key) => (
      {
        label : CONFIRM_PRICE_STATUS[key],
        value : CONFIRM_PRICE_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  PriceConfirmStatusFilter.propTypes = filterPropTypes

  const LiveProcessStatusFilter = ({ column }) => {
    const options = Object.keys(LIVE_PROCESS_STATUS).map((key) => (
      {
        label : LIVE_PROCESS_STATUS[key],
        value : LIVE_PROCESS_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  LiveProcessStatusFilter.propTypes = filterPropTypes

  // ** SELLER INVENTORY BATCH ITEM **
  const PhotographyStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTOGRAPHY_STATUSES).map((key) => (
      {
        label : PHOTOGRAPHY_STATUSES[key],
        value : PHOTOGRAPHY_STATUSES[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  PhotographyStatusFilter.propTypes = filterPropTypes

  const PhotoReceivedStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTO_RECEIVED_STATUSES).map((key) => (
      {
        label : PHOTO_RECEIVED_STATUSES[key],
        value : PHOTO_RECEIVED_STATUSES[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  PhotoReceivedStatusFilter.propTypes = filterPropTypes

  const PhotoEditStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTO_EDIT_STATUSES).map((key) => (
      {
        label : PHOTO_EDIT_STATUSES[key],
        value : PHOTO_EDIT_STATUSES[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  PhotoEditStatusFilter.propTypes = filterPropTypes

  const PhotoUploadStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTO_UPLOAD_STATUSES).map((key) => (
      {
        label : PHOTO_UPLOAD_STATUSES[key],
        value : PHOTO_UPLOAD_STATUSES[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  PhotoUploadStatusFilter.propTypes = filterPropTypes

  const PutAwayStatusFilter = ({ column }) => {
    const options = Object.keys(PUT_AWAY_STATUSES).map((key) => (
      {
        label : PUT_AWAY_STATUSES[key],
        value : PUT_AWAY_STATUSES[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  PutAwayStatusFilter.propTypes = filterPropTypes

  // ** SELLER PRODUCT PRICE CONFIRMATION **
  const StatusFilter = ({ column }) => {
    const options = Object.keys(STATUS).map((key) => (
      {
        label : STATUS[key],
        value : STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  StatusFilter.propTypes = filterPropTypes

  // ** SELLER REJECTED PRODUCT **
  const RejectReasonFilter = ({ column }) => {
    const options = Object.keys(REJECT_REASON).map((key) => (
      {
        label : REJECT_REASON[key],
        value : REJECT_REASON[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  RejectReasonFilter.propTypes = filterPropTypes

  // Custom cell
  // ** SELLER **
  const SellerTypeCell = (row) => <SellerBadge seller_type={ row.cell.value } />

  // ** SELLER PRODUCT **
  const ProductAttributePriceCell = (row) => <div>{ StringUtils.currencyCase(row.cell.value ?? '-') }</div>

  const CurationStatusCell = (row) => <SellerProductCurationStatusBadge curation_status={ row.cell.value } />

  const PriceConfirmStatusCell = (row) => <SellerProductConfrimPriceStatusBadge confirm_price_status={ row.cell.value } />

  const LiveProcessStatusCell = (row) => <SellerProductLiveProcessStatusBadge live_process_status={ row.cell.value } />

  // ** SELLER INVENTORY BATCH ITEM

  const PhotoReceiveStatusCell = (row) => <SellerInventoryBatchPhotoReceivedStatusBadge photo_received_status={ row.cell.value } />

  const PhotographyStatusCell = (row) => <SellerInventoryBatchPhotographyStatusBadge photography_status={ row.cell.value } />

  const PhotoEditStatusCell = (row) => <SellerInventoryBatchPhotoEditStatusBadge photo_edit_status={ row.cell.value } />

  const PhotoUploadStatusCell = (row) => <SellerInventoryBatchPhotoUploadStatusBadge photo_upload_status={ row.cell.value } />

  const PutAwayStatusCell = (row) => <SellerInventoryBatchPutAwayStatusBadge put_away_status={ row.cell.value } />

  // ** SELLER PRODUCT PRICE CONFIRMATION **
  const StatusCell = (row) => <PriceConfirmationStatusBadge status={ row.cell.value } />

  const AdminPriceCell = (row) => <div>{ StringUtils.currencyCase(row.cell.value ?? '-') }</div>

  const SellerConfirmedPriceCell = (row) => <div>{ StringUtils.currencyCase(row.cell.value ?? '-') }</div>

  // ** SELLER REJECTED PRODUCT **
  const RejectReasonCell = (row) => <TlRejectReasonBadge reject_reason={ row.cell.value } />

  // ** SELLER INBOUND **
  const InboundCurationStatusCell = (row) => <SellerInboundCurationStatusBadge curation_status={ row.cell.value } />

  // ** GENERAL **
  const DateCell = (row) => TimeUtil.format(row.cell.value)

  const generateActionCell = () => {

    const buttons = rowButtonProps.map((button) => {

      const ActionCell = ({ cell: { row } }) => {

        const disabled = button.isDisabled ? button.isDisabled(row.original) : false

        return (
          <RowButton
            data={ row.original }
            color={ button.colour }
            disabled={ disabled }
            onClick={ button.onClick }
            text={ button.text }
          />
        )
      }

      ActionCell.propTypes = actionCellPropTypes

      return {
        Header : button.header,
        id     : button.id,
        Cell   : ActionCell
      }
    })

    return buttons
  }

  return (
    [
      {
        Header  : 'Seller',
        columns : [
          {
            Header   : 'Name',
            id       : 'seller_name',
            accessor : 'seller.name'
          },
          {
            Header   : 'Code',
            id       : 'seller_code',
            accessor : 'seller.code'
          },
          {
            Header   : 'Type',
            id       : 'seller_type',
            accessor : 'seller.seller_type',
            Filter   : SellerTypeFilter,
            Cell     : SellerTypeCell
          }
        ]
      },
      {
        Header  : 'Seller Product',
        columns : [
          {
            Header         : 'ID',
            accessor       : 'id',
            disableFilters : true
          },
          {
            Header   : 'SKU',
            accessor : 'sku'
          },
          {
            Header   : 'Name',
            accessor : 'name'
          },
          {
            Header         : 'Brand',
            id             : 'brand',
            accessor       : 'product_attributes.brand.label',
            disableFilters : true
          },
          {
            Header   : 'Category',
            accessor : 'category'
          },
          {
            Header         : 'Quantity',
            accessor       : 'quantity',
            id             : 'quantity',
            disableFilters : true
          },
          {
            Header   : <>Curation <br/> Status</>,
            accessor : 'curation_status',
            id       : 'curation_status',
            Filter   : CurationStatusFilter,
            Cell     : CurationStatusCell
          },
          {
            Header         : 'Price',
            id             : 'product_attributes_price',
            accessor       : 'product_attributes.price',
            disableFilters : true,
            Cell           : ProductAttributePriceCell
          },
          {
            Header   : <>Confirm <br/>Price Status</>,
            accessor : 'confirm_price_status',
            id       : 'confirm_price_status',
            Filter   : PriceConfirmStatusFilter,
            Cell     : PriceConfirmStatusCell
          },
          {
            Header   : <>Live <br/>Process Status</>,
            accessor : 'live_process_status',
            id       : 'live_process_status',
            Filter   : LiveProcessStatusFilter,
            Cell     : LiveProcessStatusCell
          },
          {
            Header         : <>Live<br/>Date</>,
            accessor       : 'live_date',
            id             : 'live_date',
            disableFilters : true,
            Cell           : DateCell
          },
          {
            Header         : <>Return<br/>Date</>,
            accessor       : 'return_date',
            id             : 'return_date',
            disableFilters : true,
            Cell           : DateCell
          }
        ]
      },
      {
        Header  : 'Seller Inventory Batch Item',
        columns : [
          {
            Header   : <>Photo <br/>Received Status</>,
            accessor : 'seller_inbound_inventory_batch_item.photo_received_status',
            id       : 'seller_inbound_inventory_batch_item_photo_received_status',
            Filter   : PhotoReceivedStatusFilter,
            Cell     : PhotoReceiveStatusCell
          },
          {
            Header         : <>Photo <br/>Received Date</>,
            accessor       : 'seller_inbound_inventory_batch_item.photo_received_date',
            id             : 'seller_inbound_inventory_batch_item_photo_received_date',
            disableFilters : true,
            Cell           : DateCell
          },
          {
            Header   : <>Photography <br/>Status</>,
            accessor : 'seller_inbound_inventory_batch_item.photography_status',
            id       : 'seller_inbound_inventory_batch_item_photography_status',
            Filter   : PhotographyStatusFilter,
            Cell     : PhotographyStatusCell
          },
          {
            Header         : <>Photography <br/>Date</>,
            accessor       : 'seller_inbound_inventory_batch_item.photography_date',
            id             : 'seller_inbound_inventory_batch_item_photography_date',
            disableFilters : true,
            Cell           : DateCell
          },
          {
            Header   : <>Photo <br/>Edit Status</>,
            accessor : 'seller_inbound_inventory_batch_item.photo_edit_status',
            id       : 'seller_inbound_inventory_batch_item_photo_edit_status',
            Filter   : PhotoEditStatusFilter,
            Cell     : PhotoEditStatusCell
          },
          {
            Header         : <>Photo Edit <br/>Date</>,
            accessor       : 'seller_inbound_inventory_batch_item.photo_edited_date',
            id             : 'seller_inbound_inventory_batch_item_photo_edited_date',
            disableFilters : true,
            Cell           : DateCell
          },
          {
            Header   : <>Photo <br/>Upload Status</>,
            accessor : 'seller_inbound_inventory_batch_item.photo_upload_status',
            id       : 'seller_inbound_inventory_batch_item_photo_upload_status',
            Filter   : PhotoUploadStatusFilter,
            Cell     : PhotoUploadStatusCell
          },
          {
            Header         : <>Photo <br/>Upload Date</>,
            accessor       : 'seller_inbound_inventory_batch_item.photo_upload_date',
            id             : 'seller_inbound_inventory_batch_item_photo_upload_date',
            disableFilters : true,
            Cell           : DateCell
          },
          {
            Header   : <>Put <br/>Away Status</>,
            accessor : 'seller_inbound_inventory_batch_item.put_away_status',
            id       : 'seller_inbound_inventory_batch_item_put_away_status',
            Filter   : PutAwayStatusFilter,
            Cell     : PutAwayStatusCell
          },
          {
            Header         : <>Put <br/>Away Date</>,
            accessor       : 'seller_inbound_inventory_batch_item.put_away_date',
            id             : 'seller_inbound_inventory_batch_item_put_away_date',
            disableFilters : true,
            Cell           : DateCell
          }
        ]
      },
      {
        Header  : 'Price Confirmation',
        columns : [
          {
            Header   : 'Status',
            accessor : 'price_confirmation.status',
            id       : 'price_confirmation_status',
            Filter   : StatusFilter,
            Cell     : StatusCell
          },
          {
            Header         : 'Admin Price',
            id             : 'price_confirmation_admin_price',
            accessor       : 'price_confirmation.admin_price',
            Cell           : AdminPriceCell,
            disableFilters : true
          },
          {
            Header         : 'Seller Confirmed Price',
            id             : 'price_confirmation_seller_confirmed_price',
            accessor       : 'price_confirmation.seller_confirmed_price',
            Cell           : SellerConfirmedPriceCell,
            disableFilters : true
          }
        ]
      },
      {
        Header  : 'Seller Rejected Product',
        columns : [
          {
            Header   : <>Product Info</>,
            accessor : 'rejected_product.product_info',
            id       : 'rejected_product_product_info'
          },
          {
            Header   : <>Reject Reason</>,
            accessor : 'rejected_product.reject_reason',
            id       : 'rejected_product_reject_reason',
            Filter   : RejectReasonFilter,
            Cell     : RejectReasonCell
          },
          {
            Header         : <>Reject Note</>,
            accessor       : 'rejected_product.reject_note',
            id             : 'rejected_product_reject_note',
            disableFilters : true
          }
        ]
      },
      {
        Header  : 'Seller Inbound',
        columns : [
          {
            Header         : 'ID',
            id             : 'inbound_id',
            accessor       : 'inbound.id',
            disableFilters : true
          },
          {
            Header   : 'Code',
            id       : 'inbound_code',
            accessor : 'inbound.code'
          },
          {
            Header         : <>Received<br/>Date</>,
            accessor       : 'inbound.received_date',
            id             : 'inbound_received_date',
            disableFilters : true,
            Cell           : DateCell
          },
          {
            Header         : <>Curation<br/>Status</>,
            accessor       : 'inbound.curation_status',
            id             : 'inbound_curation_status',
            disableFilters : true,
            Cell           : InboundCurationStatusCell
          }
        ]
      },
      {
        Header  : 'Curation',
        columns : [
          {
            Header         : <>Curated<br/>Date</>,
            accessor       : 'inbound.curation.curated_date',
            id             : 'inbound_curation_curated_date',
            disableFilters : true,
            Cell           : DateCell
          }
        ]
      },
      {
        Header  : 'Actions',
        columns : [
          // * Generate action cell with buttonProps
          ...generateActionCell()
        ]
      }
    ]
  )
}

sellerProductTableColumns.propTypes = propTypes

export default sellerProductTableColumns
